import React from 'react';

export const GpsContext = React.createContext({});

export default Component => props => (
  <GpsContext.Consumer>
    {gpsStore => <Component gpsStore={gpsStore} {...props} />}
  </GpsContext.Consumer>
);
